// extracted by mini-css-extract-plugin
module.exports = {"studentInfo":"StudentInfoLabel_studentInfo__3aBZT"};